import cx from 'classnames';
import styles from '../../Leaderboard.module.scss';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { Typography } from '@navi/web-ui/lib/primitives';

type IPieChartWithIncentive = {
  realTimeCashCollectedForTeleLite: boolean;
  showDropdown: boolean;
  totalIncentiveEarnedForSelectedRadioOption: any;
  shortNumberNotationWithoutTrailingZeroesAndRounding: any;
  renderedOn?: string;
  RENDERED_ON_DASHBOARD: string;
  options: any;
  noDataInPieChart: boolean;
};

const PieChartWithIncentive = (props: IPieChartWithIncentive) => {
  const {
    realTimeCashCollectedForTeleLite,
    showDropdown,
    totalIncentiveEarnedForSelectedRadioOption,
    shortNumberNotationWithoutTrailingZeroesAndRounding,
    renderedOn,
    RENDERED_ON_DASHBOARD,
    options,
    noDataInPieChart
  } = props;
  return (
    <div
      className={cx(styles.pieChartContainer, {
        'justify-start': realTimeCashCollectedForTeleLite
      })}
    >
      <div
        className={cx(styles.incentiveSectionContainer, 'mb-[50px]', {
          'w-[35%]': showDropdown,
          'w-[30%]': !showDropdown
        })}
      >
        <div className={styles.svgContainer}>
          {shortNumberNotationWithoutTrailingZeroesAndRounding(
            totalIncentiveEarnedForSelectedRadioOption,
            2,
            '',
            1e5,
            true
          ) || `₹0`}
        </div>
      </div>

      <div
        className={cx('pr-[10px]', {
          'ml-[12%]': realTimeCashCollectedForTeleLite,
          'ml-[10%]': renderedOn !== RENDERED_ON_DASHBOARD && realTimeCashCollectedForTeleLite
        })}
      >
        <HighchartsReact highcharts={Highcharts} options={options} />
        {noDataInPieChart && (
          <Typography className={cx(styles.noDataText)} variant="p5">
            No cash collected for 30+ cases
          </Typography>
        )}
      </div>
    </div>
  );
};

export default PieChartWithIncentive;
